/**
 * Pure decision for what an Enter keydown should do inside the Autocomplete
 * combobox. Kept separate from the JSX so it is unit-testable in the project's
 * node-env Vitest setup (no jsdom / rendered DOM).
 *
 * Contract (F2 — Enter must never leak to a form's implicit submit while the
 * user is interacting with the combobox):
 *  - dropdown open + an active option           → 'select'     (pick activeIndex)
 *  - dropdown open + exactly one option, none    → 'selectOnly' (pick the obvious match, index 0)
 *    highlighted
 *  - dropdown open, otherwise                    → 'preventOnly' (swallow Enter, keep menu open)
 *  - dropdown closed                             → 'ignore'      (let Enter behave normally)
 *
 * Every non-'ignore' action means the caller MUST call preventDefault (i.e. Enter
 * never leaks to a form submit while the dropdown is open).
 *
 * @param {{ open: boolean, activeIndex: number, options: unknown[] }} state
 * @returns {{ action: 'select'|'selectOnly'|'preventOnly'|'ignore', index: number }}
 */
export function resolveEnter({ open, activeIndex, options = [] }) {
  if (!open) {
    return { action: 'ignore', index: -1 };
  }
  if (activeIndex >= 0 && activeIndex < options.length) {
    return { action: 'select', index: activeIndex };
  }
  if (options.length === 1) {
    return { action: 'selectOnly', index: 0 };
  }
  return { action: 'preventOnly', index: -1 };
}

export default resolveEnter;
